module.exports = __webpack_public_path__ + "img/tunisia.8cf7523f.svg";